import * as v from 'valibot'

export type StepDeliveryFormType = {
  guid?: string
  name: string
  startAt: Date | null
  endAt: Date | null
  cond: string
  addFriendDate: Date | null
  IsDisabled: boolean
  steps: StepDeliveryStepFormType[]
}

export type StepDeliveryStepFormType = {
  guid?: string
  targetDayAfter: number
  targetHour: number
  message: string
  answerSelections: StepDeliveryStepAnswerSelectionFormType[]
}

export type StepDeliveryStepAnswerSelectionFormType = {
  guid?: string
  selection: string
}

const baseValidStepDeliveryFormSchema = v.object({
  guid: v.optional(v.string()),
  name: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
  startAt: v.nullable(v.date()),
  endAt: v.nullable(v.date()),
  cond: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
  addFriendDate: v.nullable(v.date()),
  IsDisabled: v.boolean(),
  steps: v.pipe(
    v.array(
      v.object({
        guid: v.optional(v.string()),
        targetDayAfter: v.pipe(
          v.number(),
          v.minValue(1, '1日後以上で設定してください')
        ),
        targetHour: v.number(),
        message: v.pipe(v.string(), v.trim(), v.nonEmpty('必須です')),
        answerSelections: v.array(
          v.object({
            guid: v.optional(v.string()),
            selection: v.pipe(
              v.string(),
              v.minLength(1, '1文字以上で設定してください')
            ),
          })
        ),
      })
    ),
    v.minLength(1, '1つ以上のステップが必要です')
  ),
})

export const validStepDeliveryFormSchema = v.pipe(
  baseValidStepDeliveryFormSchema,
  // LineFollowの場合は友だち追加日を必須にする
  v.forward(
    v.partialCheck(
      [['cond'], ['addFriendDate']],
      input =>
        input.cond !== 'LineFollow' ||
        (input.cond === 'LineFollow' && input.addFriendDate !== null),
      '友だち追加日を設定してください'
    ),
    ['addFriendDate']
  )
)

export type StepDeliveryFormErrors = v.FlatErrors<
  typeof baseValidStepDeliveryFormSchema
>

export type StepDeliveryFormErrorPath = keyof NonNullable<
  StepDeliveryFormErrors['nested']
>

export type StepDeliveryFormErrorManager = {
  get: (path: StepDeliveryFormErrorPath) => string | undefined
}
